import { api } from "./api";

const subcategoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSubCategory: builder.query({
      query: () => "sub_category",
      providesTags: ["sub_category"],
    }),
    addSubCategory: builder.mutation({
      query: (newCategory) => ({
        url: "sub_category",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["sub_category"],
    }),
    removeSubCategory: builder.mutation({
      query: (id) => ({
        url: `sub_category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["sub_category"],
    }),
    editSubCategory: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/sub_category/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["sub_category"],
    }),
  }),
});

export const {
  useGetSubCategoryQuery,
  useAddSubCategoryMutation,
  useRemoveSubCategoryMutation,
  useEditSubCategoryMutation,
} = subcategoryApi;
